const API_URL = '/'
const LOGIN_URL = API_URL + 'auth/login'
const PING_URL = API_URL + 'auth/ping'
const REFRESH_URL = API_URL + 'auth/refresh'
const ACCESS_URL = API_URL + 'auth/access'
const SYSTEM_URL = API_URL + 'auth/system'
const PASSWORD_URL = API_URL + 'auth/change-password'
const FORGOT_PASSWORD_URL = API_URL + 'auth/forgot-password'
const FORGOT_PASSWORD_TOKEN_URL = API_URL + 'auth/forgot-password/token'
const USER_TERMS_CONFIRMED = API_URL + 'auth/user-terms-confirmed'
const USER_TERMS = API_URL + 'auth/user-terms'
const CONFIRM_USER_TERMS = API_URL + 'auth/confirm-user-terms'
const ERROR_TEXT = API_URL + 'auth/error-text'
const WARNING_TEXT = API_URL + 'auth/warning-text'
const INFO_TEXT = API_URL + 'auth/info-text'
const TERM_LIST = API_URL + 'auth/terms'
const STATUS_LIST = API_URL + 'status/status.json'
const LOGIN_OPTIONS = API_URL + 'auth/login-options'

export default {
  LOGIN_URL: LOGIN_URL,
  ACCESS_URL: ACCESS_URL,
  API_URL: API_URL,
  SYSTEM_URL: SYSTEM_URL,
  PASSWORD_URL: PASSWORD_URL,
  PING_URL: PING_URL,
  REFRESH_URL: REFRESH_URL,
  FORGOT_PASSWORD_URL: FORGOT_PASSWORD_URL,
  FORGOT_PASSWORD_TOKEN_URL: FORGOT_PASSWORD_TOKEN_URL,
  USER_TERMS_CONFIRMED: USER_TERMS_CONFIRMED,
  USER_TERMS: USER_TERMS,
  CONFIRM_USER_TERMS: CONFIRM_USER_TERMS,
  ERROR_TEXT: ERROR_TEXT,
  WARNING_TEXT: WARNING_TEXT,
  INFO_TEXT: INFO_TEXT,
  TERM_LIST: TERM_LIST,
  STATUS_LIST: STATUS_LIST,
  LOGIN_OPTIONS: LOGIN_OPTIONS
}
